module.exports = __webpack_public_path__ + "17cbf57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Telemedicina/images/medico.png
// module id = 1226
// module chunks = 0 1 2